import { axiosV1 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';

import { decryptResponse } from 'utils/token';

export const getInvestorDocuments =
  (investorId: string) => async (dispatch: Dispatch) => {
    const query = { params: { investorId } };
    try {
      const { data } = await axiosV1.get(`/investors/documents`, query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
